import {get, post} from './common/apiService';

export const addCart = (product_id, quantity) => {
    const data = {
        "product_id" : product_id,
        "quantity" : quantity
    }

    return post("/cart/add", data);
}

export const getCart = () => {
    return get("/cart/show");
}

export const removeFromCart = (id) => {
    return get(`/cart/delete/${id}`);
}